/* eslint-disable react-hooks/exhaustive-deps */
/*LIBRARY*/
import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

/*COMPONENT*/
import { Draggable } from "../reuseable";
import MAP_COMPONENT from "../libre_layer/MAP_COMPONENT";
import LEFT_CONTAINER from "../sidebar_map_left/LEFT_CONTAINER";
import SIDEBAR_CONTAINER from "../sidebar_map_right/SIDEBAR_CONTAINER";
import SEARCH_BAR_MAP from "../search_map/SEARCH_BAR_MAP";
import BOTTOM_BAR_CONTAINER from "../sidebar_map_right/BOTTOM_BAR_CONTAINER";
import ChatLayer from "../editor_trivial/ChatLayer";
import EDIT_LABEL from "../editor_sidebar/EDIT_LABEL";
import EDIT_LAYER_STYLE from "../layer_style_editor/EDIT_LAYER_STYLE";
import TABLE_EDITOR_PARENT from "../editor_table/TABLE_EDITOR_PARENT";
import TABLE_VIEWER_PARENT from "../viewer_table/TABLE_VIEWER_PARENT";

/*REDUX*/
import {
  setTabelStatus,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
} from "../../App/actions/layerActions";
import {
  removeDuplicateFeatures,
  setMapMode,
} from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { set_value_layer } from "../../App/actions/layerActions";
import {
  openModal,
  setModeList,
  setLanguage,
} from "../../App/actions/authActions";
import {
  set_value_properties,
  get_detail_many_layer,
} from "../../App/actions/propertiesActions";
import { getProjectDetailByLink } from "../../App/actions/projectActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/
import EDIT_SYMBOL_ICON from "../layer_style_editor/EDIT_SYMBOL_ICON";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const MAP_EDITOR = ({
  // Props
  geo_layer_link,
  mode,
  // Redux state
  project,
  layer,
  auth,
  properties,
  // Redux actions
  getProjectDetailByLink,
  getDetailLayerById,
  getDetailLayerByLinkWOgeojson,
  setChatStatus,
  set_value_properties,
  status_action,
}) => {
  const timerRef = useRef(null);
  const prevGeoProjectLinkRef = useRef(null);
  const prevGeoLayerListLengthRef = useRef(0);

  // Destructure redux state
  const { geo_project } = project;
  const { chatStatus, tableStatus, geo_layer_list, geo_layer } = layer;
  const {
    modal_edit_label_config,
    modal_edit_layer_style,
    modal_edit_symbol_icon,
    mode_map,
    geo_project_link,
  } = properties;

  const on_start = () => {
    if (!!geo_project_link) {
      const layer_list = geo_layer_list || [];
      const layer_link = geo_layer_link;
      const current_mode = mode;

      if (layer_list?.length === 0) {
        getProjectDetailByLink(geo_project_link);
      }

      let layer = layer_list.filter((e) => e.geo_layer.link === layer_link);

      timerRef.current = null;

      if (current_mode === "view" && layer.length > 0) {
        layer = layer[0].geo_layer;
        if (layer?._id) {
          const body = {
            geo_layer_id: layer._id,
            geo_project_id: geo_project._id,
            flyStatus: true,
          };
          getDetailLayerById(body);
        }
      }
    }
  };

  // ComponentDidMount
  useEffect(() => {
    on_start();
  }, []);

  // Watch for geo_project_link changes
  useEffect(() => {
    if (geo_project_link !== prevGeoProjectLinkRef.current) {
      on_start();
      prevGeoProjectLinkRef.current = geo_project_link;
    }
  }, [geo_project_link]);

  // Watch for geo_layer_list changes
  useEffect(() => {
    const current_length = geo_layer_list.length;
    const prev_length = prevGeoLayerListLengthRef.current;

    if (current_length !== prev_length && prev_length === 0) {
      const layer_link = geo_layer_link;
      const current_mode = mode;
      let layer = geo_layer_list.filter((e) => e.geo_layer.link === layer_link);

      // Get layer data if layer_link provided on the props params (mode:view)
      if (current_mode === "view" && layer.length > 0) {
        layer = layer[0].geo_layer;
        if (layer?._id) {
          const body = {
            geo_layer_id: layer._id,
            geo_project_id: geo_project._id,
            flyStatus: true,
          };
          getDetailLayerById(body);
        }
      }

      // Get layer data and activate chat if layer_link provided on the props params (mode:chat)
      if (current_mode === "chat" && layer.length > 0) {
        layer = layer[0];
        if (layer?._id) {
          const body = {
            geo_layer_id: layer._id,
            geo_project_id: geo_project._id,
            flyStatus: true,
          };
          getDetailLayerById(body);
          getDetailLayerByLinkWOgeojson(layer.link);
          setChatStatus(true);
        }
      }

      prevGeoLayerListLengthRef.current = current_length;
    }
  }, [geo_layer_list]);

  const on_close_modal_edit_label_config = () => {
    set_value_properties({
      key: "modal_edit_label_config",
      value: false,
    });
  };

  const on_close_modal_edit_layer_style = () => {
    set_value_properties({
      key: "modal_edit_layer_style",
      value: false,
    });
    set_value_properties({
      key: "is_preview_on",
      value: false,
    });
    status_action();
  };

  const on_close_modal_edit_symbol_icon = () => {
    set_value_properties({
      key: "modal_edit_symbol_icon",
      value: false,
    });
    set_value_properties({
      key: "is_preview_on",
      value: false,
    });
    status_action();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //content
  return (
    <main>
      {chatStatus && <ChatLayer />}
      <MAP_COMPONENT is_editable={true} />

      <SIDEBAR_CONTAINER />
      <BOTTOM_BAR_CONTAINER
        content={
          geo_layer?.status === "attached" || mode_map === "viewer" ? (
            <TABLE_VIEWER_PARENT />
          ) : (
            <TABLE_EDITOR_PARENT />
          )
        }
        is_open={tableStatus}
        height_var="table_height"
        drag_var="is_table_dragging"
      />
      <SEARCH_BAR_MAP />
      {modal_edit_label_config && (
        <Draggable
          title={dict?.["Map labeling"]?.[language]}
          toggle_close={on_close_modal_edit_label_config}
          style={{
            background: "white",
            width: "310px",
            zIndex: 5,
          }}
          initialPosition={{
            x: window.innerWidth - 310 - 50,
            y: 5,
          }}
        >
          <EDIT_LABEL />
        </Draggable>
      )}
      {modal_edit_layer_style && (
        <Draggable
          title="Layer style"
          toggle_close={on_close_modal_edit_layer_style}
          style={{
            background: "white",
            width: "310px",
          }}
          initialPosition={{
            x: window.innerWidth - 310 - 50,
            y: 5,
          }}
        >
          <EDIT_LAYER_STYLE />
        </Draggable>
      )}
      {modal_edit_symbol_icon && (
        <Draggable
          title="Edit Icon POI"
          toggle_close={on_close_modal_edit_symbol_icon}
          style={{
            background: "white",
            width: "310px",
            zIndex: 5,
          }}
          initialPosition={{
            x: window.innerWidth - 310 - 50,
            y: 5,
          }}
        >
          <EDIT_SYMBOL_ICON />
        </Draggable>
      )}

      <LEFT_CONTAINER />
      <Helmet>
        <title>{`${geo_project?._id ? "EDITOR" : geo_project.name}`}</title>
        <meta
          name="description"
          content={`${geo_project?._id ? "EDITOR" : geo_project.description}`}
        />
      </Helmet>
      <style>{`
      body{
        padding-top: 0px;
        overflow-y: hidden;
      }
      #navbarDefault{ visibility: hidden;}
      .top_nav{ visibility: hidden;}
      .sidebar_home{ visibility: hidden;}
   `}</style>
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
  payment: state.payment,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  setTabelStatus,
  openModal,
  setModeList,
  getDetailLayerById,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
  setLanguage,
  removeDuplicateFeatures,
  setMapMode,
  set_value_layer,
  set_value_properties,
  get_detail_many_layer,
  getProjectDetailByLink,
  status_action,
})(MAP_EDITOR);
